<template>
  <div class="modal-overlay">
    <div class="modal-side-menu" @click.stop="" v-if="!getIsMobile()">
      <div style="width: 100%; height: 150px; align-items: center; align-content: center">
        <img src="../assets/images/unpeace_white.svg" alt="로고" style="width: 100px; height: 100px;" />
        <p style="margin: 0; color: #FFFFFF;">Smart Camp</p>
      </div>
      <ul>
        <div style="height: calc(100% - 30px); overflow-y: auto;">
          <li
          v-for="modal in modalList.filter(modal => modal.abled)"
          :key="modal.key">
            <div :class="{ active: activeTab === modal.key }" @click="setActiveTab(modal.key)">
              • {{ $t(modal.title) }}
              <img v-if="modal.children" :src="menuDepthImage(activeTab === modal.key)" style="padding-right: 10px;"/>
            </div>
            <span v-if="modal.children" v-show="activeTab === modal.key">
              <div v-for="modalDepth in modal.children.filter(depth => depth.abled)"
              :key="modalDepth.key"
              :class="{ active: modalDepth.isOpen }"
              @click.stop="setChildTab(modalDepth, modal)">
                – {{ $t(modalDepth.title) }}
              </div>
            </span>
          </li>
        </div>
        <div style="display: flex; gap: 10px; width: 100%; justify-content: center; text-align: center;" v-show="false">
          <label v-for="lan in Object.keys(messages)"
            :key="lan" @click.stop="locale = lan"
            style="width: 40px; color: #FFFFFF; cursor: pointer; border-radius: 8px;"
            :style="locale === lan ? { color: '#467AEB', backgroundColor: '#FFFFFF' } : {}">
            {{ lan.toUpperCase() }}
          </label>
        </div>
      </ul>
    </div>
    <div class="modal-container" @click.stop="">
      <div class="modal-header" style="height: 76px; justify-content: space-between;" v-if="!getIsMobile()">
        <div style="border-left: 8px solid #467AEB; display: flex;">
          <h1 :style="nowSelectedDepth ? { color: '#999999' } : {}">{{ $t(modalList.find(modal => modal.key === activeTab).title) }}</h1>
          <h1 v-if="nowSelectedDepth" :style="nowSelectedDepth ? { color: '#999999' } : {}"> > </h1>
          <h1 v-if="nowSelectedDepth">{{ $t(nowSelectedDepth.title) }}</h1>
        </div>
        <div class="main-header-status-bar">
          <img src="@/assets/images/person.svg" style="cursor: default;"/>
          {{ nowLoginUser?.user_name }}
          <img src="@/assets/images/x_black.svg" @click.stop="isMenuModalOpen = false" style="padding-left: 10px; width: 40px;"/>
        </div>
      </div>
      <div class="modal-header" v-else style="gap: 20px; justify-content: space-between;">
        <img src="@/assets/images/arrow_left_gray.svg" @click="isMenuModalOpen = false"/>
        <!-- 오버레이 -->
        <div v-if="mobileMenuOpen" class="overlay" @click="mobileMenuOpen = false"></div>
        <!-- 사이드 메뉴 -->
        <nav class="side-menu" :class="{ open: mobileMenuOpen }">
          <div style="width: 100%; height: 150px; background-color: #467AEB; align-items: center; align-content: center">
            <img src="../assets/images/unpeace_white.svg" alt="로고" class="main-header-logo" style="width: 100px; height: 100px;" />
            <p style="margin: 0; color: #FFFFFF;">Smart Camp</p>
          </div>
          <ul style="display: flex; flex-direction: column; justify-content: space-between; height: calc(100% - 150px);">
            <div>
              <li
              style="font-size: 14px;"
              v-for="modal in modalList.filter(modal => modal.abled)"
              :key="modal.key">
                <div :class="{ active: activeTab === modal.key }" @click="setActiveTab(modal.key)">
                  • {{ $t(modal.title) }}
                  <img v-if="modal.children" :src="menuDepthImage(activeTab === modal.key)" style="padding-right: 10px;"/>
                </div>
                <span v-if="modal.children" v-show="activeTab === modal.key">
                  <div v-for="modalDepth in modal.children.filter(depth => depth.abled)"
                  :key="modalDepth.key"
                  :class="{ active: modalDepth.isOpen }"
                  @click.stop="setChildTab(modalDepth, modal)">
                    – {{ $t(modalDepth.title) }}
                  </div>
                </span>
              </li>
            </div>
            <div>
              <li style="text-align: center; padding: 0;" @click="changeLanguage()" v-show="false">
                {{ $t('change_language') }}
              </li>
            </div>
          </ul>
        </nav>
        <h2 v-if="!nowSelectedDepth" style="padding-left: 16px; font-size: 17px;">{{ $t(modalList.find(modal => modal.key === activeTab).title) }}</h2>
        <h2 v-else style="padding-left: 16px; font-size: 17px;">{{ $t(nowSelectedDepth.title) }}</h2>
        <img src="@/assets/images/menu_mobile_gray.svg" @click="mobileMenuOpen = !mobileMenuOpen" />
      </div>
      <div class="modal-body">
        <UserModal v-if="modalList.find(modal => modal.key === 'User').abled && modalList.find(modal => modal.key === 'User').isOpen" />
        <ManageDeviceModal v-if="modalList.find(modal => modal.key === 'Device').isOpen" />
        <!-- <ManageGroupModal v-if="modalList.find(modal => modal.key === 'Group').isOpen" /> -->
        <GeoFenceModal v-if="modalList.find(modal => modal.key === 'Geo').isOpen" />
        <AuthorityModal v-if="modalList.find(modal => modal.key === 'Auth').isOpen" />
        <POIModal v-if="modalList.find(modal => modal.key === 'POI').isOpen" />
        <EventModal v-if="modalList.find(modal => modal.key === 'Event').isOpen" />
        <LogViewModal v-if="modalList.find(modal => modal.key === 'Log').isOpen" />
        <OperationModal v-if="modalList.find(modal => modal.key === 'Operation').isOpen" />
        <CpeModal v-if="modalList.find(modal => modal.key === 'CPE').isOpen" />
        <LiveUpdateModal v-if="modalList.find(modal => modal.key === 'Live').isOpen" />
        <StatisticsModal v-if="modalList.find(modal => modal.key === 'Statistics').isOpen" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import { getIsMobile, nowLoginUserID } from '@/utils/GlobalUtility';
import { loadingStore } from "@/utils/LoadingStore";
import UserModal from '@/modals/UserModal.vue';
import LiveUpdateModal from './LiveUpdateModal.vue';
import ManageDeviceModal from '@/modals/DeviceModal.vue';
// import ManageGroupModal from '@/modals/GroupModal.vue';
import GeoFenceModal from '@/modals/GeoFenceModal.vue';
import AuthorityModal from '@/modals/AuthorityModal.vue';
import EventModal from '@/modals/EntryExitRecordsModal.vue';
import LogViewModal from '@/modals/LogViewModal.vue';
import OperationModal from '@/modals/OperationModal.vue';
import StatisticsModal from '@/modals/StatisticsModal.vue';
import { GET_SERVER_REQUEST, user_list } from '@/utils/ServerConnect';
import { useI18n } from 'vue-i18n';
import { isMenuModalOpen, modalList, nowSelectedDepth, showSmallModal } from '../utils/ModalUtility';
import POIModal from './POIModal.vue';
import CpeModal from './CpeModal.vue';



const nowLoginUser = ref();
const isRoot = ref(false);
const activeTab = ref('User'); // 활성화된 탭
const mobileMenuOpen = ref(false);

// 탭 변경
const setActiveTab = (tab) => {
  if (activeTab.value === tab) return;
  showSmallModal.value = false;
  activeTab.value = tab;

  if (modalList.value.find(modal => modal.key === tab)) {
    modalList.value.filter(modal => modal.isOpen).forEach(modal => { modal.isOpen = false; });
    modalList.value.filter(modal => modal.children).forEach(modal => { modal.children?.forEach(child => { child.isOpen = false; }) });
    nowSelectedDepth.value = null;
    
    const modalControl = modalList.value.find(modal => modal.key === tab);
    modalControl.isOpen = true;

    const childCheck = modalControl.children;
    if (childCheck) {
      childCheck[0].isOpen = true;
      nowSelectedDepth.value = childCheck[0];
    }
  } else {
    modalList.value.filter(modal => modal.isOpen).forEach(modal => { modal.isOpen = false; });
  }

  if (getIsMobile() && !modalList.value.find(modal => modal.key === tab)?.children) mobileMenuOpen.value = false;
};
const setChildTab = (child, modal) => {
  if (child.isOpen) return;
  modal.children.filter(child => child.isOpen).forEach(child => { child.isOpen = false; })
  child.isOpen = true;
  nowSelectedDepth.value = child;
}

const { locale, messages } = useI18n();
const changeLanguage = () => {
  const languages = Object.keys(messages.value);
  const currentIndex = languages.indexOf(locale.value);
  const nextIndex = (currentIndex + 1) % languages.length;

  locale.value = languages[nextIndex];
}

// 🖼️ 메뉴 펼침/닫음 이미지 경로 반환
const menuDepthImage = (isOpen) => {
  if (isOpen) return new URL('../assets/images/arrow_up_gray.svg', import.meta.url).href;
  return new URL('../assets/images/arrow_down_gray.svg', import.meta.url).href;
};

onMounted(() => {
  loadingStore.showLoading();
  nextTick(async () => {
    user_list.value = await GET_SERVER_REQUEST('user');
    nowLoginUser.value = user_list.value.find(user => user.user_account === nowLoginUserID.value)

    isRoot.value = nowLoginUser.value?.role === 'root';

    // 활성화 되어있는 가장 첫번째 탭을 기본으로 보여줌
    setActiveTab(modalList.value.find(modal => modal.abled).key);
  })
  loadingStore.hideLoading();
});
onUnmounted(() => {
  loadingStore.hideLoading();
});
</script>

<style scoped>
/* 오버레이 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
/* 사이드 메뉴 */
.side-menu {
  position: fixed;
  top: 0;
  left: -250px;
  width: 250px;
  height: 100%;
  background: #E3E9F2;
  box-shadow: 2px 0 8px rgba(0,0,0,0.1);
  z-index: 1002;
  transition: left 0.3s ease;
}
.side-menu.open {
  left: 0;
}
.side-menu ul {
  margin-top: 0;
  list-style: none;
  padding: 5px;
  text-align: left;
  overflow-y: auto;
}
.side-menu li div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  border-radius: 8px;
  height: 46px;
}
.side-menu li div.active {
  color: #FFFFFF;
  font-weight: bold;
  background-color: #467AEB;
}
.side-menu li span div {
  padding-left: 25px;
  border-radius: 8px;
  height: 46px;
  align-content: center;
  color: #5C5C5C;
}
.side-menu li span div.active {
  color: #000000;
  font-weight: bold;
  background-color: transparent;
}
</style>